<h3 i18n>Edit user</h3>
@if (navLinks$ | async; as navLinks) {
  <nav mat-tab-nav-bar>
    @for (link of navLinks; track link) {
      <a mat-tab-link
        [routerLink]="link.path"
        routerLinkActive #rla="routerLinkActive"
        [active]="rla.isActive">
        {{link.label}}
      </a>
    }
  </nav>
  <router-outlet></router-outlet>
}
